export default {
    addToList: 'Add to the list',
    inviteToBoard: 'Invite to the platform',
    openPassport: 'Open passport'
};
